import * as React from 'react';
import { getBox } from "../../primitives";
import { getChipStyle } from "./Chip.styles";
export var BaseChip = getBox(getChipStyle);